module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Confirmation","message":"Are you sure?"},"et":{"title":"Confirmation","message":"Are you sure?"},"ru":{"title":"Confirmation","message":"Are you sure?"}}')
  delete Component.options._Ctor
}
